const search =
{
    tooltip : 'Rechercher'
};

export default search ;